import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';


function HistoryFooter({ totalProfitLoss,deposit }) {
    const {t} = useTranslation()

    return (
        <div>
            <Grid container alignItems="center" justifyContent="space-between" style={{ height: '100%', }}>
                <Grid item style={{ display: 'flex' }} pl={1} gap={2} className="td-ellipsis">
                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}>{t('profit')}: {(totalProfitLoss)?.toFixed(2) || "0.00"}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('deposit')}: {deposit || "0.00"} </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t("withdrawal")}: {"0.00"} </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('adjustment')}: {"0.00"} </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t("creditIn")}: {"0.00"} </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}> {t('creditOut')}: {"0.00"} </Typography>
                </Grid>
            </Grid>
        </div>
    );
}

export default HistoryFooter;
